// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lztlmniinqehhxbqftsn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx6dGxtbmlpbnFlaGh4YnFmdHNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2NDc0NDcsImV4cCI6MjA3MTIyMzQ0N30.1CGVyyqV3FtLSN9c4KVkA9wksd-0WQ269rDLtOr5Ho4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Required for Google/Apple OAuth redirects to /auth/callback —
    // Supabase detects the session from the URL hash on load.
    detectSessionInUrl: true,
  }
});